
export interface WorkoutType {
  id: string;
  name: string;
  description: string | null;
  color: string;
  is_active: boolean;
  organization_id: string;
  created_at: string;
  updated_at: string;
  created_by: string | null;
  updated_by: string | null;
}

// Default colors for workout types
export const WORKOUT_COLORS = [
  "#3498db", // Blue
  "#2ecc71", // Green
  "#e74c3c", // Red
  "#f39c12", // Orange
  "#9b59b6", // Purple
  "#1abc9c", // Teal
  "#e67e22", // Dark Orange
  "#34495e", // Navy
];
